<template>
  <div>
    <div v-if="status=='credit'">
        เครดิต
    </div>
    <div v-else-if="status=='wallet'">เงินสด</div>
        
  </div>
</template>

<script>
export default {
  data(){
    return{
      
    }
  },
  props: {
    status:{
      type:String,
      default:""
    } 
  },
  methods:{

  },
  computed:{

  },
  watch:{

  },
  components: {
   
  },
};
</script>

<style>

</style>